module.exports = __webpack_public_path__ + "img/513A11_CDBEB5_C8811C_9A733F-256px.9c876174.png";